import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { TextField, TextFieldProps } from '@mui/material'

type Props = TextFieldProps & {
  name: string
  control: Control | any
  errorMessage?: string | null
  label?: string
  value?: string
}

export function FormInputText ({ name, control, label, value, errorMessage, ...rest }: Props) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={(value ? value : '')}
      render={({ field: { onChange, value }, fieldState: { invalid } }) => {
        return <TextField
          {...rest}
          error={invalid}
          value={value || ''}
          onChange={onChange}
          fullWidth
          label={label}
          helperText={errorMessage}
          autoComplete="off"
        />
      }} />
  )
}
